export default __webpack_public_path__ + "static/media/header_2.3627bb0b.jpg";